(() => {
  const root = document.querySelector("[data-kob-product-release-control]");
  if (!root || !root.querySelector("[data-kob-prc-import-form]")) return;

  const endpoint = String(root.dataset.endpoint || "").replace(/\/$/, "");
  const arrivalEndpoint = String(root.dataset.arrivalEndpoint || "https://ownership.kind-of-blu.com").replace(/\/$/, "");
  const refs = {
    email: root.querySelector("[data-kob-prc-email]"),
    alias: root.querySelector("[data-kob-prc-alias]"),
    token: root.querySelector("[data-kob-prc-token]"),
    writeMode: root.querySelector("[data-kob-prc-write-mode]"),
    importForm: root.querySelector("[data-kob-prc-import-form]"),
    bulkDetails: root.querySelector("[data-kob-prc-bulk-panel]"),
    quickDetails: root.querySelector(".kob-prc__quick"),
    openManual: root.querySelector("[data-kob-prc-open-manual]"),
    openArrivals: root.querySelector("[data-kob-prc-open-arrivals]"),
    arrivalPanel: root.querySelector("[data-kob-prc-arrival-panel]"),
    arrivalSummary: root.querySelector("[data-kob-prc-arrival-summary]"),
    arrivalList: root.querySelector("[data-kob-prc-arrival-list]"),
    quickForm: root.querySelector("[data-kob-prc-quick-form]"),
    quickButton: root.querySelector("[data-kob-prc-quick]"),
    editCancel: root.querySelector("[data-kob-prc-edit-cancel]"),
    formOptional: root.querySelector("[data-kob-prc-form-optional]"),
    formError: root.querySelector("[data-kob-prc-form-error]"),
    explicitPoints: root.querySelector("[data-kob-prc-explicit-points]"),
    collectionPicker: root.querySelector("[data-kob-prc-collection-picker]"),
    collectionSummary: root.querySelector("[data-kob-prc-collection-summary]"),
    collectionOptions: root.querySelector("[data-kob-prc-collection-options]"),
    collectionsInput: root.querySelector("[data-kob-prc-collections]"),
    collectionSearch: root.querySelector("[data-kob-prc-collection-search]"),
    collectionRefresh: root.querySelector("[data-kob-prc-collection-refresh]"),
    collectionStatus: root.querySelector("[data-kob-prc-collection-status]"),
    collectionTitle: root.querySelector("[data-kob-prc-collection-title]"),
    collectionConfirm: root.querySelector("[data-kob-prc-collection-confirm]"),
    collectionCreate: root.querySelector("[data-kob-prc-collection-create]"),
    collectionCreateStatus: root.querySelector("[data-kob-prc-collection-create-status]"),
    localMedia: root.querySelector("[data-kob-prc-local-media]"),
    mediaNote: root.querySelector("[data-kob-prc-media-note]"),
    previewImage: root.querySelector("[data-kob-prc-preview-image]"),
    previewMedia: root.querySelector("[data-kob-prc-preview-media]"),
    previewMaker: root.querySelector("[data-kob-prc-preview-maker]"),
    previewLimited: root.querySelector("[data-kob-prc-preview-limited]"),
    previewTitle: root.querySelector("[data-kob-prc-preview-title]"),
    previewSubtitle: root.querySelector("[data-kob-prc-preview-subtitle]"),
    previewPrice: root.querySelector("[data-kob-prc-preview-price]"),
    previewPoints: root.querySelector("[data-kob-prc-preview-points]"),
    previewShip: root.querySelector("[data-kob-prc-preview-ship]"),
    previewLanguageButtons: Array.from(root.querySelectorAll("[data-kob-prc-preview-language]")),
    previewLabels: Array.from(root.querySelectorAll("[data-kob-prc-preview-label]")),
    previewActions: Array.from(root.querySelectorAll("[data-kob-prc-preview-action]")),
    previewNote: root.querySelector("[data-kob-prc-preview-note]"),
    importButton: root.querySelector("[data-kob-prc-import]"),
    fileName: root.querySelector("[data-kob-prc-file-name]"),
    batchSelect: root.querySelector("[data-kob-prc-batch-select]"),
    toolbar: root.querySelector(".kob-prc__toolbar"),
    filter: root.querySelector("[data-kob-prc-filter]"),
    refresh: root.querySelector("[data-kob-prc-refresh]"),
    startWorkflow: root.querySelector("[data-kob-prc-start-workflow]"),
    workflowStatus: root.querySelector("[data-kob-prc-workflow-status]"),
    revalidate: root.querySelector("[data-kob-prc-revalidate]"),
    plan: root.querySelector("[data-kob-prc-plan]"),
    prepareExecution: root.querySelector("[data-kob-prc-prepare-execution]"),
    continueExecution: root.querySelector("[data-kob-prc-continue-execution]"),
    executions: root.querySelector("[data-kob-prc-executions]"),
    refreshPublications: root.querySelector("[data-kob-prc-refresh-publications]"),
    publishSelected: root.querySelector("[data-kob-prc-publish-selected]"),
    publications: root.querySelector("[data-kob-prc-publications]"),
    refreshCommunications: root.querySelector("[data-kob-prc-refresh-communications]"),
    communications: root.querySelector("[data-kob-prc-communications]"),
    legacyEmail: root.querySelector("[data-kob-prc-legacy-email]"),
    title: root.querySelector("[data-kob-prc-selected-title]"),
    status: root.querySelector("[data-kob-prc-selected-status]"),
    items: root.querySelector("[data-kob-prc-items]"),
    liveStock: root.querySelector("[data-kob-prc-live-stock]"),
    liveClose: root.querySelector("[data-kob-prc-live-close]"),
    liveCode: root.querySelector("[data-kob-prc-live-code]"),
    liveName: root.querySelector("[data-kob-prc-live-name]"),
    liveLocation: root.querySelector("[data-kob-prc-live-location]"),
    livePreviewButton: root.querySelector("[data-kob-prc-live-preview]"),
    liveStatus: root.querySelector("[data-kob-prc-live-status]"),
    liveError: root.querySelector("[data-kob-prc-live-error]"),
    liveResult: root.querySelector("[data-kob-prc-live-result]"),
    liveProduct: root.querySelector("[data-kob-prc-live-product]"),
    liveProductLink: root.querySelector("[data-kob-prc-live-link]"),
    liveReviewedLocation: root.querySelector("[data-kob-prc-live-reviewed-location]"),
    liveCurrent: root.querySelector("[data-kob-prc-live-current]"),
    liveForm: root.querySelector("[data-kob-prc-live-form]"),
    liveTarget: root.querySelector("[data-kob-prc-live-target]"),
    liveConfirm: root.querySelector("[data-kob-prc-live-confirm]"),
    liveApply: root.querySelector("[data-kob-prc-live-apply]"),
    liveReceipt: root.querySelector("[data-kob-prc-live-receipt]"),
    liveNewDraft: root.querySelector("[data-kob-prc-live-new-draft]"),
    events: root.querySelector("[data-kob-prc-events]"),
    toast: root.querySelector("[data-kob-prc-toast]"),
  };
  const state = { batches: [], items: [], events: [], runs: [], publications: [], communications: [], collectionOptions: [], collectionDirectoryStatus: "loading", collectionCreateMode: "disabled", collectionBusy: false, arrivalCandidates: [], arrivalLoaded: false, selectedBatchId: "", writeMode: "disabled", publishMode: "disabled", replenishmentMode: "disabled", stockReceipts: {}, snsHandoffWarnings: {}, socialPublishMode: "disabled", captionGenerationMode: "disabled", captionGenerationPrimary: "none", loading: false, workflowRunning: false, liveStockBusy: false, liveStockManualReview: false, liveStockItemId: "", liveStockPreview: null, liveStockPending: null, toastTimer: 0, previewMediaUrl: "", previewLocale: "en", editingItemId: "" };

  const previewCopy = {
    en: {
      titleFallback: "Product title", makerFallback: "Model maker", edition: (value) => `Limited to ${value}`,
      shipTokyo: "Ships from Tokyo", shipShanghai: "Ships from Shanghai",
      labels: { scale: "Scale", material: "Material", code: "Product code" },
      actions: { quantity: "Quantity", cart: "Add to cart" },
      note: "Only verified product notes will appear below the specification block.",
      materials: { Resin: "Resin", Diecast: "Diecast", Composite: "Composite", Other: "Other" },
    },
    ja: {
      titleFallback: "商品名", makerFallback: "メーカー", edition: (value) => `世界限定 ${value}台`,
      shipTokyo: "発送元：東京", shipShanghai: "発送元：上海",
      labels: { scale: "スケール", material: "素材", code: "品番" },
      actions: { quantity: "数量", cart: "カートに入れる" },
      note: "確認済みの商品情報のみ、仕様欄の下に掲載されます。",
      materials: { Resin: "レジン", Diecast: "ダイキャスト", Composite: "コンポジット", Other: "その他" },
    },
    zh: {
      titleFallback: "商品名称", makerFallback: "模型厂商", edition: (value) => `全球限量 ${value} 台`,
      shipTokyo: "发货地：东京", shipShanghai: "发货地：上海",
      labels: { scale: "比例", material: "材质", code: "货号" },
      actions: { quantity: "数量", cart: "加入购物车" },
      note: "仅在确认信息准确后，才会在规格栏下方显示商品说明。",
      materials: { Resin: "树脂", Diecast: "合金", Composite: "复合材质", Other: "其他" },
    },
  };

  async function api(path, options = {}) {
    const formData = options.body instanceof FormData;
    const ownerHeaders = {
      authorization: `Bearer ${refs.token?.value || ""}`,
      "x-kob-owner-email": refs.email?.value || "",
      "x-kob-owner-alias": refs.alias?.value || "",
    };
    const response = await fetch(`${endpoint}${path}`, {
      credentials: "same-origin",
      ...options,
      headers: formData
        ? { ...ownerHeaders, ...(options.headers || {}) }
        : { "content-type": "application/json", ...ownerHeaders, ...(options.headers || {}) },
    });
    let payload;
    try { payload = await response.json(); } catch { payload = { ok: false, error: `HTTP ${response.status}` }; }
    if (!response.ok || !payload.ok) {
      const error = new Error(payload.detail || payload.error || `HTTP ${response.status}`);
      error.code = payload.error || "";
      error.status = response.status;
      error.receipt = payload.receipt || null;
      error.manualReviewRequired = payload.manual_review_required === true;
      throw error;
    }
    return payload;
  }

  function setLoading(value) {
    state.loading = value;
    updateCollectionCreateButton();
    root.classList.toggle("is-loading", value);
    if (refs.importButton) refs.importButton.disabled = value;
    if (refs.quickButton) refs.quickButton.disabled = value;
    if (refs.refresh) refs.refresh.disabled = value;
    if (refs.startWorkflow) refs.startWorkflow.disabled = value || !canStartWorkflow();
    if (refs.revalidate) refs.revalidate.disabled = value || !state.selectedBatchId;
    if (refs.plan) refs.plan.disabled = value || !state.selectedBatchId;
    if (refs.prepareExecution) refs.prepareExecution.disabled = value || !canPrepareExecution();
    if (refs.continueExecution) refs.continueExecution.disabled = value || !canContinueExecution();
    if (refs.refreshPublications) refs.refreshPublications.disabled = value || !state.selectedBatchId;
    if (refs.publishSelected) refs.publishSelected.disabled = value || !publishableSelections().length;
    if (refs.refreshCommunications) refs.refreshCommunications.disabled = value || !state.selectedBatchId;
  }

  function toast(message) {
    if (!refs.toast) return;
    window.clearTimeout(state.toastTimer);
    refs.toast.textContent = message;
    refs.toast.classList.add("is-visible");
    state.toastTimer = window.setTimeout(() => refs.toast.classList.remove("is-visible"), 3600);
  }

  function setFormError(message = "") {
    if (!refs.formError) return;
    refs.formError.textContent = message;
    refs.formError.hidden = !message;
  }

  function syncSourceButtons() {
    const manualOpen = Boolean(refs.quickDetails?.open);
    const arrivalsOpen = Boolean(refs.arrivalPanel && !refs.arrivalPanel.hidden);
    if (refs.openManual) refs.openManual.setAttribute("aria-expanded", String(manualOpen));
    if (refs.openArrivals) refs.openArrivals.setAttribute("aria-expanded", String(arrivalsOpen));
    root.classList.toggle("is-source-open", manualOpen || arrivalsOpen);
  }

  function renderArrivalCandidates() {
    if (!refs.arrivalList || !state.arrivalLoaded) return;
    const candidates = state.arrivalCandidates;
    if (refs.arrivalSummary) refs.arrivalSummary.textContent = candidates.length
      ? `${candidates.length} arrival line${candidates.length === 1 ? "" : "s"} found. Remaining stock is a live estimate; Arrivals confirms the handoff after photos are ready.`
      : "No Make Up surplus candidate is currently listed. Check Arrivals & Balances for the full arrival record and photo status.";
    refs.arrivalList.innerHTML = candidates.map((candidate) => {
      const code = candidate.variant_code || candidate.arrival_line_id || "Unidentified line";
      const stage = ({
        waiting_photos: "Waiting for physical photos",
        ready: "Ready to prepare in Arrivals",
        claimed: "Handoff in progress",
        linked: "Product details linked",
        skipped: "Not entering catalog",
      })[candidate.handoff_state] || "Review in Arrivals";
      const stock = candidate.inventory_qty != null && Number.isFinite(Number(candidate.inventory_qty))
        ? formatNumber(candidate.inventory_qty) : "—";
      const linkedBatch = candidate.handoff_state === "linked" && candidate.product_release_batch_id;
      return `<article class="kob-prc__arrival-card">
        <strong>${escapeHtml(code)}</strong>
        <span>${escapeHtml(candidate.product_title || candidate.release_id || "Make Up arrival")}</span>
        <span>${escapeHtml(stage)} · ${escapeHtml(stock)} current surplus</span>
        ${linkedBatch ? `<button type="button" class="kob-prc__text-action" data-kob-prc-arrival-batch="${escapeHtml(candidate.product_release_batch_id)}">Open product details</button>` : ""}
      </article>`;
    }).join("");
  }

  async function loadArrivalCandidates() {
    if (refs.arrivalSummary) refs.arrivalSummary.textContent = "Checking Make Up arrival surplus and photo status...";
    try {
      const response = await fetch(`${arrivalEndpoint}/makeup-arrivals/catalog-candidates.json`, {
        credentials: "same-origin",
        headers: {
          authorization: `Bearer ${refs.token?.value || ""}`,
          "x-kob-owner-email": refs.email?.value || "",
          "x-kob-owner-alias": refs.alias?.value || "",
        },
      });
      const payload = await response.json();
      if (!response.ok || !payload.ok) throw new Error(payload.detail || payload.error || `HTTP ${response.status}`);
      state.arrivalCandidates = Array.isArray(payload.candidates) ? payload.candidates : [];
      state.arrivalLoaded = true;
      renderArrivalCandidates();
    } catch {
      if (refs.arrivalSummary) refs.arrivalSummary.textContent = "The live arrival queue is unavailable here. Open Arrivals & Balances to check photos and prepare a handoff.";
      if (refs.arrivalList) refs.arrivalList.innerHTML = "";
    }
  }

  async function load(batchId = state.selectedBatchId) {
    setLoading(true);
    try {
      const query = batchId ? `?batch_id=${encodeURIComponent(batchId)}` : "";
      const payload = await api(`/product-releases/admin.json${query}`);
      state.batches = payload.batches || [];
      state.items = payload.items || [];
      state.events = payload.events || [];
      state.runs = payload.runs || [];
      state.publications = payload.publications || [];
      recordSnsHandoffs(payload.sns_handoffs);
      state.communications = payload.communications || [];
      state.collectionOptions = payload.collection_options || [];
      state.collectionDirectoryStatus = payload.collection_directory?.status || "unavailable";
      state.collectionCreateMode = payload.collection_create_mode || "disabled";
      state.selectedBatchId = payload.selected_batch_id || "";
      state.writeMode = payload.write_mode || "disabled";
      state.publishMode = payload.publish_mode || "disabled";
      state.replenishmentMode = payload.replenishment_mode || "disabled";
      state.stockReceipts = {};
      if (String(selectedBatch()?.source_ref || "").startsWith("makeup-arrival:")) {
        await Promise.all(state.items.filter((item) => item.normalized?.action === "skip").map(async (item) => {
          try {
            const query = `?batch_id=${encodeURIComponent(state.selectedBatchId)}&item_id=${encodeURIComponent(item.item_id)}`;
            const result = await api(`/product-releases/replenishment/receipts.json${query}`);
            state.stockReceipts[item.item_id] = result.receipts?.[0] || null;
          } catch { state.stockReceipts[item.item_id] = null; }
        }));
      }
      state.socialPublishMode = payload.social_publish_mode || "disabled";
      state.captionGenerationMode = payload.caption_generation_mode || "disabled";
      state.captionGenerationPrimary = payload.caption_generation_primary || "none";
      if (refs.liveStock && !refs.liveStock.hidden) {
        if (!state.items.some((item) => item.item_id === state.liveStockItemId)) {
          refs.liveStock.hidden = true;
          state.liveStockItemId = "";
        }
        clearLiveStockReview("The product queue changed. Re-read live Shopify stock before setting a target.");
      }
      render();
    } finally {
      setLoading(false);
    }
  }

  function render() {
    if (refs.writeMode) refs.writeMode.textContent = state.writeMode === "enabled" ? "Draft execution ready" : "Draft execution locked";
    renderBatches();
    renderSummary();
    renderItems();
    renderExecutions();
    renderPublications();
    renderCommunications();
    renderEvents();
    renderCollectionPicker();
    renderWorkflowStatus();
    renderArrivalCandidates();
    syncSourceButtons();
    if (refs.prepareExecution) refs.prepareExecution.disabled = state.loading || !canPrepareExecution();
    if (refs.startWorkflow) refs.startWorkflow.disabled = state.loading || !canStartWorkflow();
    if (refs.publishSelected) refs.publishSelected.disabled = state.loading || !publishableSelections().length;
    if (refs.continueExecution) {
      refs.continueExecution.disabled = state.loading || !canContinueExecution();
      refs.continueExecution.title = state.writeMode === "enabled"
        ? (activeRun() ? "Run one reviewed, idempotent Shopify Draft step" : "Prepare a reviewed Draft run first")
        : "Draft execution is disabled by the global safety switch";
    }
  }

  function renderBatches() {
    if (!refs.batchSelect) return;
    const batches = selectedBatch() && !state.batches.some((batch) => batch.batch_id === state.selectedBatchId)
      ? [selectedBatch(), ...state.batches] : state.batches;
    refs.batchSelect.innerHTML = batches.length
      ? batches.map((batch) => `<option value="${escapeHtml(batch.batch_id)}"${batch.batch_id === state.selectedBatchId ? " selected" : ""}>${escapeHtml(batch.title)} / ${escapeHtml(batch.status)}</option>`).join("")
      : '<option value="">No batches</option>';
    const batch = selectedBatch();
    if (refs.title) refs.title.textContent = batch?.title || "Select a batch";
    if (refs.status) refs.status.textContent = batch?.status || "Not loaded";
  }

  function renderSummary() {
    const batch = selectedBatch();
    const values = {
      rows: batch?.row_count || 0,
      ready: batch?.ready_count || 0,
      warnings: batch?.warning_count || 0,
      errors: batch?.error_count || 0,
      planned: state.items.filter((item) => item.plan).length,
    };
    Object.entries(values).forEach(([key, value]) => {
      const element = root.querySelector(`[data-kob-prc-summary-value="${key}"]`);
      if (element) element.textContent = String(value);
    });
  }

  function renderWorkflowStatus() {
    if (!refs.workflowStatus) return;
    const run = state.runs[0];
    if (state.workflowRunning) {
      refs.workflowStatus.textContent = run
        ? `Creating Drafts: ${formatNumber(run.completed_count)} of ${formatNumber(run.item_count)} products complete.`
        : "Validating products and preparing the Shopify plan...";
      return;
    }
    if (!run) {
      const batch = selectedBatch();
      refs.workflowStatus.textContent = !batch ? "Choose a source above to prepare a product."
        : Number(batch.error_count || 0) > 0 ? "Fix the errors shown on the product before Draft creation."
          : state.items.every((item) => item.normalized?.action === "skip") ? "All products are on hold. Edit one to continue."
            : "Next: check the source and create Shopify Drafts. Nothing publishes yet.";
      if (refs.startWorkflow) refs.startWorkflow.textContent = "Create Shopify Drafts";
      return;
    }
    if (run.status === "completed") refs.workflowStatus.textContent = "All Shopify Drafts are ready for review.";
    else if (run.status === "completed_with_errors") refs.workflowStatus.textContent = `${formatNumber(run.completed_count)} Drafts ready; ${formatNumber(run.failed_count)} product(s) need attention.`;
    else if (["prepared", "running", "waiting", "failed"].includes(run.status)) refs.workflowStatus.textContent = "Draft creation can continue safely from its saved progress.";
    else refs.workflowStatus.textContent = `Latest run: ${run.status}.`;
    if (refs.startWorkflow) refs.startWorkflow.textContent = activeRun() ? "Continue Shopify Drafts"
      : run.status === "completed" ? "Shopify Drafts created" : "Create Shopify Drafts";
  }

  function renderItems() {
    if (!refs.items) return;
    const filter = refs.filter?.value || "all";
    const items = state.items.filter((item) => filter === "all" || item.status === filter);
    if (!items.length) {
      refs.items.innerHTML = '<tr><td colspan="5">No products in this view.</td></tr>';
      return;
    }
    refs.items.innerHTML = items.map((item) => {
      const product = item.normalized || {};
      const localeNames = Object.entries(product.localizations || {})
        .filter(([, copy]) => Object.values(copy || {}).some(Boolean))
        .map(([locale]) => locale === "zh-CN" ? "ZH" : locale.toUpperCase());
      const media = product.media_source === "local"
        ? `${(item.media || []).length} original file${(item.media || []).length === 1 ? "" : "s"} staged privately`
        : `Drive / ${product.media_reference || item.factory_code || "FactoryCode"}`;
      const issues = (item.issues || []).map((issue) => `<li data-severity="${escapeHtml(issue.severity)}">${escapeHtml(issue.message)}</li>`).join("");
      const plan = renderPlan(item.plan);
      const next = itemNextAction(item);
      const edit = next.kind === "edit" ? "" : `<button class="kob-prc__text-action" type="button" data-kob-prc-edit-item="${escapeHtml(item.item_id)}">Edit details</button>`;
      const action = next.kind === "published"
        ? `<a class="kob-prc-button kob-prc__row-action" href="${escapeHtml(next.url)}" target="_blank" rel="noopener">Open product page</a>`
        : `<button class="kob-prc-button kob-prc__row-action" type="button" data-kob-prc-row-action="${escapeHtml(next.kind)}" data-kob-prc-row-id="${escapeHtml(next.id || item.item_id)}">${escapeHtml(next.label)}</button>`;
      return `<tr>
        <td data-label="Product"><strong>${escapeHtml(item.factory_code || "No code")}</strong><small>${escapeHtml([product.vendor, product.title || item.title || "Untitled"].filter(Boolean).join(" / "))}</small>${product.subtitle ? `<small>${escapeHtml(product.subtitle)}</small>` : ""}${localeNames.length ? `<small>Reviewed copy: ${escapeHtml(localeNames.join(" + "))}</small>` : ""}${edit}</td>
        <td data-label="Current stage"><span class="kob-prc__row-status">${escapeHtml(next.stage)}</span><small>${escapeHtml(next.detail)}</small><span class="kob-prc__status kob-prc__status--${escapeHtml(item.status)}">${escapeHtml(item.status)}</span>${issues ? `<ul class="kob-prc__issues">${issues}</ul>` : ""}${plan}</td>
        <td data-label="Original photos">${escapeHtml(media)}<small>${product.media_source === "local" ? "Local source" : "Folder is checked during the Shopify plan / Draft run"}</small></td>
        <td data-label="Price / stock">JPY ${formatNumber(product.price)}<small>${formatNumber(product.inventory)} at ${escapeHtml(product.stock_location || "No location")}</small></td>
        <td data-label="Next action">${action}</td>
      </tr>`;
    }).join("");
  }

  function itemNextAction(item) {
    const publication = state.publications.find((record) => record.item_id === item.item_id);
    if (publication?.status === "published" && publication.product_url) return {
      stage: "Product page published", detail: "Shopify confirmed the public URL.", kind: "published", url: publication.product_url,
    };
    if (publication && ["review_ready", "publish_failed", "publish_incomplete", "review_blocked"].includes(publication.status)) return {
      stage: publicationStatusLabel(publication.status), detail: "Inspect the exact Shopify snapshot and images.", kind: "review", id: publication.publication_record_id, label: "Review Shopify Draft",
    };
    const stockReceipt = state.stockReceipts[item.item_id];
    if (stockReceipt && ["applied", "claimed", "uncertain"].includes(stockReceipt.status)) return {
      stage: stockReceipt.status === "applied" ? "Live stock update verified" : "Live stock outcome needs manual review",
      detail: stockReceipt.status === "applied"
        ? `${formatNumber(stockReceipt.verified_available)} total available at ${stockReceipt.location_name || "the reviewed location"}.`
        : "Check the saved stock receipt and Shopify inventory before any further action.",
      kind: "live-stock", label: stockReceipt.status === "applied" ? "View stock receipt" : "Review stock outcome",
    };
    const runItem = state.runs[0]?.items?.find((entry) => entry.item_id === item.item_id);
    if (runItem && ["failed", "waiting"].includes(runItem.status)) return {
      stage: "Draft needs attention", detail: runItem.error_message || "Inspect the saved step before retrying.", kind: "recovery", label: "Open recovery details",
    };
    if (runItem && ["pending", "running"].includes(runItem.status)) return {
      stage: "Creating Shopify Draft", detail: "Progress is saved after each step.", kind: "workflow", label: "Continue Draft creation",
    };
    if (item.status === "invalid" || Number(item.error_count || 0) > 0) return {
      stage: "Product details need correction", detail: "Fix the issues shown here before creating a Draft.", kind: "edit", label: "Fix product details",
    };
    if (item.plan && !["ready", "skipped"].includes(item.plan.status)) {
      const reason = `${item.plan.reason || ""} ${item.plan.message || ""}`;
      if (String(selectedBatch()?.source_ref || "").startsWith("makeup-arrival:")
        && /existing_product_not_draft/i.test(reason)) return {
        stage: "Existing live product needs stock review",
        detail: "The Draft executor cannot edit ACTIVE products. Set Shopify action to Hold / skip, then review live stock.",
        kind: "edit", label: "Return to stock review",
      };
      return {
        stage: /image|photo|media|drive/i.test(reason) ? "Photo source needs attention" : "Shopify plan needs correction",
        detail: reason || "Inspect the Shopify plan, then update the product record.", kind: "edit", label: "Fix product details",
      };
    }
    if (item.plan?.status === "skipped" || item.normalized?.action === "skip") {
      const muHandoff = String(selectedBatch()?.source_ref || "").startsWith("makeup-arrival:");
      return muHandoff ? {
        stage: "MU handoff awaiting product check",
        detail: "Check whether the same FactoryCode is already live. Verify photos and total stock before any Shopify change.",
        kind: "live-stock", label: "Check live product & stock",
      } : {
        stage: "On hold", detail: "This product is excluded from the Draft run.", kind: "edit", label: "Edit hold",
      };
    }
    if (runItem?.status === "completed") return {
      stage: "Shopify Draft created", detail: "Refresh the Shopify review snapshot.", kind: "refresh-review", label: "Refresh Draft review",
    };
    return {
      stage: item.plan?.status === "ready" ? "Ready for Shopify Draft" : "Details saved; source not checked",
      detail: item.plan?.status === "ready" ? "The reviewed plan is ready." : "Draft creation first checks Shopify and the photo source.",
      kind: "workflow", label: "Go to Draft action",
    };
  }

  function liveStockItem() {
    return state.items.find((item) => item.item_id === state.liveStockItemId) || null;
  }

  function latestStockReceipt() {
    return state.stockReceipts[state.liveStockItemId] || null;
  }

  function stockActionBlocked() {
    return state.liveStockManualReview || ["applied", "claimed", "uncertain"].includes(latestStockReceipt()?.status);
  }

  function renderLiveStockReceipt() {
    const receipt = latestStockReceipt();
    if (!refs.liveReceipt) return;
    refs.liveReceipt.hidden = !receipt && !state.liveStockManualReview;
    if (refs.liveReceipt.hidden) return;
    refs.liveReceipt.dataset.status = receipt?.status || "uncertain";
    refs.liveReceipt.textContent = receipt?.status === "applied"
      ? `Saved Shopify receipt: ${formatNumber(receipt.verified_available)} total available at ${receipt.location_name}. This MU handoff is complete; do not apply its arrival remainder again.`
      : receipt?.status === "conflict"
        ? "The previous stock attempt found a stale Shopify quantity and made no adjustment. Read current stock before reviewing a new total."
      : `Stock outcome ${receipt?.status || "unknown"}. Review the saved request ${receipt?.request_id || "in Shopify"} and current Shopify inventory manually. This workspace will not submit another stock update for this handoff.`;
  }

  function clearLiveStockReview(message = "Choose the location and read Shopify before entering a target.") {
    state.liveStockPreview = null;
    state.liveStockPending = null;
    if (refs.liveResult) refs.liveResult.hidden = true;
    if (refs.liveTarget) refs.liveTarget.value = "";
    if (refs.liveConfirm) refs.liveConfirm.checked = false;
    if (refs.liveStatus) refs.liveStatus.textContent = message;
    if (refs.liveError) refs.liveError.hidden = true;
    if (refs.liveNewDraft) refs.liveNewDraft.hidden = true;
    updateLiveApplyState();
  }

  function showLiveStockError(message) {
    if (!refs.liveError) return;
    refs.liveError.textContent = message;
    refs.liveError.hidden = false;
  }

  function setLiveStockBusy(value) {
    state.liveStockBusy = value;
    if (refs.livePreviewButton) refs.livePreviewButton.disabled = value;
    if (refs.liveLocation) refs.liveLocation.disabled = value;
    if (refs.liveClose) refs.liveClose.disabled = value;
    updateLiveApplyState();
  }

  function updateLiveApplyState() {
    const raw = String(refs.liveTarget?.value || "").trim();
    const target = Number(raw);
    const valid = raw !== "" && Number.isSafeInteger(target) && target >= 0 && target <= 1000000000;
    if (refs.liveApply) refs.liveApply.disabled = state.liveStockBusy || state.replenishmentMode !== "enabled"
      || stockActionBlocked() || !state.liveStockPreview || !valid || !refs.liveConfirm?.checked;
  }

  function renderLiveStockSnapshot() {
    const preview = state.liveStockPreview;
    if (!preview) return;
    if (refs.liveResult) refs.liveResult.hidden = false;
    if (refs.liveProduct) refs.liveProduct.textContent = `${preview.product?.title || preview.factory_code || "Product"} · ${preview.product?.status || "Unknown"}`;
    if (refs.liveReviewedLocation) refs.liveReviewedLocation.textContent = preview.inventory?.location_name || refs.liveLocation?.value || "—";
    if (refs.liveCurrent) refs.liveCurrent.textContent = formatNumber(preview.inventory?.available);
    if (refs.liveProductLink) {
      const url = String(preview.product?.online_store_url || "");
      let safeUrl = "";
      try {
        const parsed = new URL(url);
        if (parsed.protocol === "https:") safeUrl = parsed.toString();
      } catch {}
      refs.liveProductLink.hidden = !safeUrl;
      if (safeUrl) refs.liveProductLink.href = safeUrl;
      else refs.liveProductLink.removeAttribute("href");
    }
    if (refs.liveStatus) refs.liveStatus.textContent = state.replenishmentMode === "enabled"
      ? (stockActionBlocked() ? "Shopify stock was read for comparison. This handoff already has a saved stock decision." : "Shopify stock was read. Enter the reviewed total available at this location.")
      : "Shopify stock was read. Stock updates are currently locked.";
    updateLiveApplyState();
  }

  function newLiveStockRequestId() {
    if (typeof crypto.randomUUID === "function") return crypto.randomUUID();
    const bytes = new Uint8Array(16);
    crypto.getRandomValues(bytes);
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    const hex = Array.from(bytes, (value) => value.toString(16).padStart(2, "0")).join("");
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
  }

  function openLiveStock(itemId) {
    const item = state.items.find((entry) => entry.item_id === itemId);
    if (!item || !String(selectedBatch()?.source_ref || "").startsWith("makeup-arrival:")) return;
    state.liveStockItemId = itemId;
    state.liveStockManualReview = false;
    if (refs.liveCode) refs.liveCode.textContent = item.factory_code || "FactoryCode";
    if (refs.liveName) refs.liveName.textContent = item.normalized?.title || item.title || "";
    if (refs.liveLocation) {
      const location = String(item.normalized?.stock_location || "");
      if (Array.from(refs.liveLocation.options).some((option) => option.value === location)) refs.liveLocation.value = location;
    }
    clearLiveStockReview();
    renderLiveStockReceipt();
    if (refs.liveStock) refs.liveStock.hidden = false;
    refs.liveStock?.scrollIntoView({ behavior: "smooth", block: "start" });
    if (!stockActionBlocked()) readLiveStock();
  }

  async function readLiveStock() {
    const item = liveStockItem();
    if (!item || !refs.liveLocation) return;
    clearLiveStockReview("Reading the exact Shopify product and current stock...");
    renderLiveStockReceipt();
    setLiveStockBusy(true);
    try {
      const preview = await api("/product-releases/replenishment/preview", {
        method: "POST",
        body: JSON.stringify({
          batch_id: state.selectedBatchId,
          item_id: item.item_id,
          stock_location: refs.liveLocation.value,
        }),
      });
      if (!preview.eligible || preview.product?.status !== "ACTIVE" || !preview.inventory) {
        throw new Error("Shopify did not return one eligible ACTIVE product and its location stock.");
      }
      state.liveStockPreview = preview;
      renderLiveStockSnapshot();
    } catch (error) {
      const descriptions = {
        factory_code_not_found: "Shopify search found no exact FactoryCode match right now. Its index may lag; verify directly in Shopify before choosing a new Draft.",
        factory_code_ambiguous: "More than one exact Shopify product matches this FactoryCode. Resolve the identity in Shopify before changing stock.",
        existing_product_not_active: "The matching Shopify product is not ACTIVE. Inspect it in Shopify; this live-stock path cannot update it.",
        existing_product_not_online_store: "The matching ACTIVE product is not published to Online Store. Review it in Shopify before changing stock here.",
        inventory_location_not_found: "This stock location could not be found in Shopify. Choose and verify the correct location.",
        inventory_level_not_active: "This product has no active stock level at the selected location. Review it in Shopify.",
        inventory_untracked: "Shopify does not track inventory for this product. Review its settings in Shopify.",
        multiple_variants: "This product has multiple variants. Review the exact variant in Shopify before changing stock.",
        item_action_not_skip: "This MU item must remain on Hold / skip for the live-stock path.",
      };
      showLiveStockError(descriptions[error.code] || `Could not read live stock: ${error.message}`);
      if (refs.liveStatus) refs.liveStatus.textContent = "No stock change was made.";
      if (refs.liveNewDraft) refs.liveNewDraft.hidden = error.code !== "factory_code_not_found" || stockActionBlocked();
    } finally {
      setLiveStockBusy(false);
    }
  }

  async function applyLiveStock(event) {
    event.preventDefault();
    const item = liveStockItem();
    const preview = state.liveStockPreview;
    if (!item || !preview || !refs.liveForm?.reportValidity() || state.replenishmentMode !== "enabled" || stockActionBlocked()) return;
    const target = Number(refs.liveTarget.value);
    if (!Number.isSafeInteger(target) || target < 0 || target > 1000000000 || !refs.liveConfirm.checked) return;
    const current = Number(preview.inventory.available);
    const location = refs.liveLocation.value;
    if (!window.confirm(`Set ${item.factory_code} at ${location} from ${current} to ${target} total available units? This replaces the absolute stock target; it does not add arrival quantity.`)) return;
    const values = {
      batch_id: state.selectedBatchId,
      item_id: item.item_id,
      stock_location: location,
      product_id: preview.product.id,
      inventory_item_id: preview.inventory.inventory_item_id,
      location_id: preview.inventory.location_id,
      expected_available: current,
      target_available: target,
      confirm_absolute_target: true,
    };
    const key = JSON.stringify(values);
    const requestId = state.liveStockPending?.key === key ? state.liveStockPending.requestId : newLiveStockRequestId();
    state.liveStockPending = { key, requestId };
    setLiveStockBusy(true);
    if (refs.liveError) refs.liveError.hidden = true;
    if (refs.liveStatus) refs.liveStatus.textContent = "Setting the reviewed absolute total and verifying Shopify readback...";
    try {
      const result = await api("/product-releases/replenishment/apply", {
        method: "POST",
        body: JSON.stringify({ ...values, request_id: requestId }),
      });
      const confirmed = result.inventory?.available;
      if (result.receipt?.status !== "applied" || result.receipt?.verified_available !== target || confirmed !== target) {
        state.liveStockManualReview = true;
        if (result.receipt) state.stockReceipts[item.item_id] = result.receipt;
        renderLiveStockReceipt();
        updateLiveApplyState();
        showLiveStockError("The returned receipt did not verify the requested total. Review the saved receipt and Shopify inventory manually; do not retry this stock change here.");
        return;
      }
      state.stockReceipts[item.item_id] = result.receipt;
      state.liveStockPreview.inventory.available = confirmed;
      state.liveStockPending = null;
      if (refs.liveTarget) refs.liveTarget.value = "";
      if (refs.liveConfirm) refs.liveConfirm.checked = false;
      renderLiveStockSnapshot();
      renderLiveStockReceipt();
      renderItems();
      toast("Live product stock updated and verified.");
    } catch (error) {
      if (error.receipt) {
        state.stockReceipts[item.item_id] = error.receipt;
        renderLiveStockReceipt();
        renderItems();
      }
      if (error.manualReviewRequired || ["claimed", "uncertain"].includes(error.receipt?.status)) {
        state.liveStockManualReview = true;
        showLiveStockError("Shopify may have changed, but the outcome is not verified. Check the saved receipt and Shopify inventory manually; this workspace will not submit another update for this handoff.");
      } else if (error.receipt?.status === "applied") {
        showLiveStockError("A previous request already completed this handoff. Check the saved Shopify receipt; no new stock update was submitted.");
      } else if (error.status === 409) {
        clearLiveStockReview("The Shopify snapshot changed. Read live stock again before entering a new target.");
        showLiveStockError("Stock or product identity changed before the update. No further write was attempted; re-read Shopify and review the total.");
      } else if (error.status === 423) {
        state.replenishmentMode = "disabled";
        showLiveStockError("Live-stock updates are locked. No further write is available until this workspace is enabled.");
      } else {
        state.liveStockManualReview = true;
        showLiveStockError(`Could not confirm the stock outcome: ${error.message}. Check Shopify and the saved request before taking any further stock action.`);
      }
    } finally {
      setLiveStockBusy(false);
    }
  }

  function renderPlan(plan) {
    if (!plan) return '<span class="kob-prc__status">Not built</span>';
    const diffs = (plan.diffs || []).map((diff) => `<li>${escapeHtml(diff.field)}</li>`).join("");
    const steps = (plan.steps || []).map((step) => `<li>${escapeHtml(step.label)}</li>`).join("");
    const reason = plan.message || plan.reason || "";
    return `<details class="kob-prc__plan"><summary>${escapeHtml(plan.action)} / ${escapeHtml(plan.status)}</summary>${reason ? `<small>${escapeHtml(reason)}</small>` : ""}${diffs ? `<ul><li><strong>${plan.diffs.length} field change${plan.diffs.length === 1 ? "" : "s"}</strong></li>${diffs}</ul>` : ""}${steps ? `<ol>${steps}</ol>` : ""}</details>`;
  }

  function renderEvents() {
    if (!refs.events) return;
    refs.events.innerHTML = state.events.length
      ? state.events.map((event) => `<article class="kob-prc__event"><strong>${escapeHtml(event.event_type)}</strong><span>${escapeHtml(event.actor_email || "system")}</span><span>${escapeHtml(formatDate(event.created_at))}</span></article>`).join("")
      : "<p>No activity.</p>";
  }

  function renderExecutions() {
    if (!refs.executions) return;
    if (!state.runs.length) {
      refs.executions.innerHTML = "<p>No execution run prepared.</p>";
      return;
    }
    refs.executions.innerHTML = state.runs.map((run, index) => {
      const counts = `${formatNumber(run.completed_count)} of ${formatNumber(run.item_count)} products complete`;
      const items = (run.items || []).map((runItem) => {
        const source = state.items.find((item) => item.item_id === runItem.item_id);
        const identity = [source?.factory_code || "Unknown product", source?.title || ""].filter(Boolean).join(" / ");
        const steps = (runItem.steps || []).map((step) => {
          const retryable = ["failed", "waiting"].includes(step.status);
          const retry = retryable ? `<button type="button" class="kob-prc__text-action" data-kob-prc-retry-step="${escapeHtml(step.step_id)}">Retry step</button>` : "";
          return `<li class="kob-prc__execution-step" data-status="${escapeHtml(step.status)}"><span class="kob-prc__execution-index">${formatNumber(step.step_order)}</span><div><strong>${escapeHtml(step.label)}</strong><small>${escapeHtml(step.status)} · attempt ${formatNumber(step.attempt_count)}</small>${step.error_message ? `<p>${escapeHtml(step.error_message)}</p>` : ""}${retry}</div></li>`;
        }).join("");
        return `<article class="kob-prc__run-item"><header><strong>${escapeHtml(identity)}</strong><span class="kob-prc__status">${escapeHtml(runItem.action)} / ${escapeHtml(runItem.status)}</span></header><ol>${steps}</ol></article>`;
      }).join("");
      return `<details class="kob-prc__run"${index === 0 ? " open" : ""}><summary><div><span class="kob-prc__status">${escapeHtml(run.status)}</span><strong>${escapeHtml(counts)}</strong><small>${escapeHtml(formatDate(run.created_at))}</small></div><span>${escapeHtml(run.mode || "draft_only")}</span></summary>${run.error_message ? `<p class="kob-prc__run-error">${escapeHtml(run.error_message)}</p>` : ""}<div class="kob-prc__run-items">${items || "<p>No run items.</p>"}</div></details>`;
    }).join("");
  }

  function recordSnsHandoffs(reports) {
    for (const report of reports || []) {
      if (!report?.publication_record_id) continue;
      if (report.ok) delete state.snsHandoffWarnings[report.publication_record_id];
      else state.snsHandoffWarnings[report.publication_record_id] = report.error || "candidate not yet saved";
    }
  }

  function renderPublications() {
    if (!refs.publications) return;
    if (!state.publications.length) {
      refs.publications.innerHTML = "<p>Complete Shopify Draft creation to begin review.</p>";
      return;
    }
    refs.publications.innerHTML = `<div class="kob-prc__publication-grid">${state.publications.map((record) => {
      const snapshot = record.snapshot || {};
      const source = state.items.find((item) => item.item_id === record.item_id);
      const identity = snapshot.title || source?.title || source?.factory_code || "Product";
      const ready = ["review_ready", "publish_failed", "publish_incomplete"].includes(record.status) && Boolean(record.snapshot_hash);
      const disabled = !ready || record.status === "published" ? " disabled" : "";
      const images = (snapshot.media || []).filter((media) => media.url).slice(0, 3)
        .map((media) => `<img src="${escapeHtml(media.url)}" alt="${escapeHtml(media.alt || identity)}" loading="lazy" width="480" height="360">`).join("");
      const preview = record.status === "published" && record.product_url
        ? `<a href="${escapeHtml(record.product_url)}" target="_blank" rel="noopener">Open product page</a>`
        : (record.preview_url
          ? `<a href="${escapeHtml(record.preview_url)}" target="_blank" rel="noopener">Open exact storefront preview</a>`
          : (record.product_url ? `<a href="${escapeHtml(record.product_url)}" target="_blank" rel="noopener">Open product page</a>` : ""));
      const publicity = record.status === "published" && record.product_url
        ? '<a href="/pages/kob-sns-studio">Prepare SNS post</a>' : "";
      const handoffWarning = state.snsHandoffWarnings[record.publication_record_id];
      const handoffStatus = record.status === "published"
        ? `<p class="kob-prc__publication-handoff"${handoffWarning ? ' role="alert"' : ""}>${handoffWarning
          ? `SNS handoff pending: ${escapeHtml(handoffWarning)}. The product page is published; check the handoff before preparing a post.`
          : "SNS handoff can be checked here before preparing a post."} <button class="kob-prc__text-action" type="button" data-kob-prc-check-sns-handoff="${escapeHtml(record.publication_record_id)}">Check SNS handoff</button></p>` : "";
      return `<article class="kob-prc__publication" data-kob-prc-publication="${escapeHtml(record.publication_record_id)}">
        <header><div><p class="kob-prc__eyebrow">${escapeHtml(snapshot.vendor || "Shopify Draft")}</p><h3>${escapeHtml(identity)}</h3></div><span class="kob-prc__status">${escapeHtml(publicationStatusLabel(record.status))}</span></header>
        <div class="kob-prc__publication-media">${images || "<span>No ready images</span>"}</div>
        <div class="kob-prc__publication-details">
          <div><span>Product code</span><strong>${escapeHtml(snapshot.factory_code || source?.factory_code || "-")}</strong></div>
          <div><span>Subtitle</span><strong>${escapeHtml(snapshot.subtitle || "-")}</strong></div>
          <div><span>Price</span><strong>JPY ${formatNumber(snapshot.price)}</strong></div>
          <div><span>Inventory</span><strong>${formatNumber(snapshot.inventory)} / ${escapeHtml(snapshot.stock_location || "-")}</strong></div>
          <div><span>Limited</span><strong>${escapeHtml(snapshot.edition_size || "-")}</strong></div>
          <div><span>Media</span><strong>${formatNumber((snapshot.media || []).length)} ready</strong></div>
        </div>
        ${record.error_message ? `<p class="kob-prc__publication-error">${escapeHtml(record.error_message)}</p>` : ""}
        ${handoffStatus}
        <div class="kob-prc__publication-actions"><label class="kob-prc__publication-select"><input type="checkbox" data-kob-prc-publication-select value="${escapeHtml(record.publication_record_id)}"${disabled}><span>${record.status === "published" ? "Published" : "I checked this page and want to publish"}</span></label><div class="kob-prc__publication-links">${preview}${publicity}</div></div>
      </article>`;
    }).join("")}</div>`;
  }

  function publicationStatusLabel(status) {
    return ({
      review_pending: "Preparing review",
      review_ready: "Ready to publish",
      review_blocked: "Needs correction",
      publishing: "Publishing",
      publish_failed: "Retry available",
      publish_incomplete: "Publication incomplete",
      published: "Published",
    })[status] || status || "Unknown";
  }

  function renderCommunications() {
    if (!refs.communications) return;
    const legacyEmails = state.communications.filter((item) => item.channel === "email" && !["prepared", "published", "cancelled"].includes(item.status));
    if (refs.legacyEmail) refs.legacyEmail.hidden = !legacyEmails.length;
    if (!legacyEmails.length) {
      refs.communications.innerHTML = "";
      return;
    }
    refs.communications.innerHTML = `<div class="kob-prc__communication-grid">${legacyEmails.map((item) => {
      const source = state.items.find((candidate) => candidate.item_id === item.item_id);
      const identity = [source?.factory_code, source?.title].filter(Boolean).join(" / ") || "Product release";
      const locked = item.status === "waiting_publication";
      const complete = item.status === "published";
      const openProduct = item.product_url ? `<a class="kob-prc-button" href="${escapeHtml(item.product_url)}" target="_blank" rel="noopener">Open product</a>` : "";
      if (item.channel === "email") {
        return `<article class="kob-prc__communication" data-kob-prc-communication="${escapeHtml(item.communication_id)}">
          <header><div><p class="kob-prc__eyebrow">Shopify Messaging pack</p><h3>${escapeHtml(identity)}</h3></div><span class="kob-prc__status" data-kob-prc-communication-status>${escapeHtml(item.status)}</span></header>
          <p class="kob-prc__communication-meta">Exports reviewed HTML for Shopify Messaging. It never sends subscriber email directly.</p>
          <label><span>Subject</span><input type="text" data-kob-prc-communication-subject value="${escapeHtml(item.subject)}"></label>
          <label><span>Body copy</span><textarea data-kob-prc-communication-body>${escapeHtml(item.body_text)}</textarea></label>
          ${item.error_message ? `<p class="kob-prc__communication-error">${escapeHtml(item.error_message)}</p>` : ""}
          <div class="kob-prc__communication-actions"><button class="kob-prc-button" type="button" data-kob-prc-save-communication>Save copy</button><button class="kob-prc-button kob-prc-button--primary" type="button" data-kob-prc-export-email${locked ? " disabled" : ""}>Download email HTML</button><button class="kob-prc-button kob-prc-button--quiet" type="button" data-kob-prc-cancel-communication>Abandon task</button>${openProduct}</div>
        </article>`;
      }
      const socialDisabled = state.socialPublishMode !== "enabled" || locked || complete;
      const generationLocked = state.captionGenerationMode !== "enabled" || locked || complete || socialHasStarted(item.provider_state || {});
      const canCancel = !complete && !item.provider_state?.ig_media_id && !item.provider_state?.fb_post_id;
      const socialLabel = complete ? "Published" : (state.socialPublishMode === "enabled" ? (item.status === "failed" ? "Retry IG/FB" : "Publish IG/FB") : "IG/FB locked");
      const progress = socialProgress(item.provider_state || {}, item.media || []);
      const generation = item.caption_generation || {};
      const sources = (generation.sources || []).map((source) => `<a href="${escapeHtml(source.url)}" target="_blank" rel="noopener">${escapeHtml(source.title || "Source")}</a>`).join(" · ");
      const generationMeta = generation.provider
        ? `<p class="kob-prc__generation-meta">Generated with ${escapeHtml(generation.provider)} / ${escapeHtml(generation.model || "")}${generation.confidence ? ` · ${escapeHtml(generation.confidence)} confidence` : ""}${sources ? `<br>${sources}` : ""}</p>`
        : `<p class="kob-prc__generation-meta">Optional researched English context. Generation runs only when requested; the caption remains editable.</p>`;
      return `<article class="kob-prc__communication" data-kob-prc-communication="${escapeHtml(item.communication_id)}">
        <header><div><p class="kob-prc__eyebrow">Meta carousel</p><h3>${escapeHtml(identity)}</h3></div><span class="kob-prc__status" data-kob-prc-communication-status>${escapeHtml(item.status)}</span></header>
        <p class="kob-prc__communication-meta" data-kob-prc-communication-progress>${escapeHtml(progress)} / ${(item.media || []).length} image${(item.media || []).length === 1 ? "" : "s"}</p>
        <div class="kob-prc__introduction-head"><span>Social introduction</span><button class="kob-prc-button" type="button" data-kob-prc-generate-introduction${generationLocked ? " disabled" : ""}>Generate researched intro</button></div>
        <textarea class="kob-prc__introduction" data-kob-prc-communication-introduction placeholder="Optional researched English context">${escapeHtml(item.social_introduction || "")}</textarea>
        ${generationMeta}
        <label><span>IG / FB caption</span><textarea data-kob-prc-communication-caption>${escapeHtml(item.caption)}</textarea></label>
        ${item.error_message ? `<p class="kob-prc__communication-error">${escapeHtml(item.error_message)}</p>` : ""}
        <div class="kob-prc__communication-actions"><button class="kob-prc-button" type="button" data-kob-prc-save-communication>Save caption</button><button class="kob-prc-button kob-prc-button--primary" type="button" data-kob-prc-publish-social${socialDisabled ? " disabled" : ""}>${escapeHtml(socialLabel)}</button>${canCancel ? '<button class="kob-prc-button kob-prc-button--quiet" type="button" data-kob-prc-cancel-communication>Abandon task</button>' : ""}${openProduct}</div>
      </article>`;
    }).join("")}</div>`;
  }

  function socialProgress(providerState, media) {
    if (providerState.fb_post_id) return "Instagram and Facebook complete";
    if (providerState.ig_media_id) return `Instagram published; Facebook ${(providerState.fb_photo_ids || []).length}/${media.length}`;
    if (providerState.ig_container_id) return "Instagram carousel prepared";
    return `Instagram media ${(providerState.ig_child_ids || []).length}/${media.length}`;
  }

  function socialHasStarted(providerState) {
    return Boolean(providerState.ig_container_id || providerState.ig_media_id || providerState.fb_post_id
      || (providerState.ig_child_ids || []).length || (providerState.fb_photo_ids || []).length);
  }

  function selectedBatch() {
    const listed = state.batches.find((batch) => batch.batch_id === state.selectedBatchId);
    if (listed) return listed;
    if (!state.selectedBatchId || !state.items.length) return null;
    return {
      batch_id: state.selectedBatchId, title: "Linked product batch", status: "loaded",
      row_count: state.items.length,
      ready_count: state.items.filter((item) => item.status === "ready").length,
      warning_count: state.items.reduce((total, item) => total + Number(item.warning_count || 0), 0),
      error_count: state.items.reduce((total, item) => total + Number(item.error_count || 0), 0),
    };
  }

  function activeRun() {
    return state.runs.find((run) => ["prepared", "running", "waiting", "failed"].includes(run.status)) || null;
  }

  function canPrepareExecution() {
    return Boolean(state.selectedBatchId && state.items.length && state.items.every((item) => item.plan));
  }

  function canContinueExecution() {
    return state.writeMode === "enabled" && Boolean(activeRun());
  }

  function canStartWorkflow() {
    const batch = selectedBatch();
    return state.writeMode === "enabled" && Boolean(batch && state.items.length
      && state.items.some((item) => item.normalized?.action !== "skip")
      && Number(batch.error_count || 0) === 0 && !state.workflowRunning
      && state.runs[0]?.status !== "completed");
  }

  function publishableSelections() {
    if (state.publishMode !== "enabled") return [];
    return Array.from(refs.publications?.querySelectorAll("[data-kob-prc-publication-select]:checked") || []);
  }

  function quickValue(name) {
    const value = String(refs.quickForm?.elements?.[name]?.value || "").trim();
    if (value === "Other") return String(refs.quickForm?.elements?.[`${name}_other`]?.value || "").trim();
    return value;
  }

  function setQuickValue(name, value) {
    const field = refs.quickForm?.elements?.[name];
    if (!field) return;
    if (!field.type && typeof field.length === "number") {
      Array.from(field).forEach((input) => { input.checked = input.value === String(value ?? ""); });
      return;
    }
    if (field.type === "checkbox") {
      field.checked = Boolean(value);
      return;
    }
    const other = refs.quickForm?.elements?.[`${name}_other`];
    if (field.tagName === "SELECT" && other) {
      const normalized = value == null ? "" : String(value);
      const supported = Array.from(field.options).some((option) => option.value === normalized);
      field.value = supported ? normalized : (normalized ? "Other" : "");
      other.value = supported ? "" : normalized;
      other.hidden = field.value !== "Other";
      return;
    }
    field.value = value == null ? "" : String(value);
  }

  function parseCollections(value) {
    const values = Array.isArray(value) ? value : String(value || "").split("|");
    return Array.from(new Set(values.map((entry) => String(entry || "").trim()).filter(Boolean)));
  }

  function selectedCollections() {
    return parseCollections(refs.collectionsInput?.value);
  }

  function collectionTitles() {
    const live = (state.collectionOptions || []).map((entry) => String(entry?.title || entry || "").trim()).filter(Boolean);
    return Array.from(new Set([...live, ...selectedCollections(), "New Arrivals"])).sort((left, right) => left.localeCompare(right, "en", { sensitivity: "base" }));
  }

  function updateCollectionSummary() {
    if (!refs.collectionSummary) return;
    const selected = selectedCollections();
    refs.collectionSummary.textContent = selected.length === 0
      ? "Choose collections"
      : (selected.length === 1 ? selected[0] : `${selected[0]} + ${selected.length - 1} more`);
  }

  function setSelectedCollections(values) {
    if (!refs.collectionsInput) return;
    refs.collectionsInput.value = parseCollections(values).join(" | ");
    renderCollectionPicker();
  }

  function renderCollectionPicker() {
    if (!refs.collectionOptions) return;
    const selected = new Set(selectedCollections());
    const search = (refs.collectionSearch?.value || "").trim().toLowerCase();
    const entries = collectionTitles().filter((title) => title.toLowerCase().includes(search));
    refs.collectionOptions.innerHTML = entries.map((title) => {
      const matches = state.collectionOptions.filter((entry) => entry.title === title);
      const entry = matches[0] || {};
      const automatic = entry.automatic === true;
      const disabled = state.collectionBusy || (!selected.has(title) && (state.collectionDirectoryStatus !== "ready" || automatic || matches.length > 1 || entry.selectable === false));
      const note = automatic ? "Automatic — products join by Shopify rules" : matches.length > 1 ? "Duplicate title — review in Shopify" : !entry.id ? "Not verified in Shopify" : "Manual collection";
      const rules = (entry.rules || []).map((rule) => `${rule.column} ${rule.relation} ${rule.condition}`).join("; ");
      return `<label><input type="checkbox" aria-label="${escapeHtml(title)}" value="${escapeHtml(title)}" ${selected.has(title) ? "checked" : ""} ${disabled ? "disabled" : ""}><span><span>${escapeHtml(title)}</span><small>${escapeHtml(note)}${rules ? `<br>${escapeHtml(rules)}` : ""}</small></span></label>`;
    }).join("") || '<p class="kob-prc__collection-note">No matching collections.</p>';
    refs.collectionOptions.querySelectorAll('input[type="checkbox"]').forEach((input) => {
      input.addEventListener("change", () => {
        const values = new Set(selectedCollections());
        if (input.checked) values.add(input.value); else values.delete(input.value);
        refs.collectionsInput.value = Array.from(values).sort((a, b) => a.localeCompare(b, "en", { sensitivity: "base" })).join(" | ");
        updateCollectionSummary();
      });
    });
    if (refs.collectionStatus) refs.collectionStatus.textContent = state.collectionDirectoryStatus === "ready"
      ? "Shopify collections loaded. Automatic collections use rules and cannot be selected manually."
      : state.collectionDirectoryStatus === "loading" ? "Loading Shopify collections…" : "Could not load Shopify collections. Refresh to try again; saved selections are retained.";
    if (refs.collectionRefresh) refs.collectionRefresh.disabled = state.collectionBusy;
    updateCollectionCreateButton();
    updateCollectionSummary();
  }

  function updateCollectionCreateButton() {
    if (refs.collectionCreate) refs.collectionCreate.disabled = state.collectionBusy || state.loading || state.collectionDirectoryStatus !== "ready" || state.collectionCreateMode !== "enabled" || !refs.collectionConfirm?.checked || !refs.collectionTitle?.value.trim();
  }

  async function refreshCollections() {
    state.collectionBusy = true;
    renderCollectionPicker();
    try {
      const payload = await api("/product-releases/collections.json");
      state.collectionOptions = payload.collection_options || [];
      state.collectionDirectoryStatus = payload.collection_directory?.status || "unavailable";
    } catch {
      state.collectionDirectoryStatus = "unavailable";
    } finally {
      state.collectionBusy = false;
      renderCollectionPicker();
    }
  }

  async function createCollection() {
    if (refs.collectionCreate?.disabled) return;
    state.collectionBusy = true;
    setLoading(true);
    renderCollectionPicker();
    if (refs.collectionCreateStatus) refs.collectionCreateStatus.textContent = "Creating collection in Shopify…";
    try {
      const payload = await api("/product-releases/collections/create", {
        method: "POST", body: JSON.stringify({ title: refs.collectionTitle.value.trim(), confirmation: "CREATE_SHOPIFY_COLLECTION" }),
      });
      state.collectionOptions = [...state.collectionOptions.filter((entry) => entry.id !== payload.collection.id), payload.collection];
      setSelectedCollections([...selectedCollections(), payload.collection.title]);
      refs.collectionTitle.value = "";
      refs.collectionConfirm.checked = false;
      if (refs.collectionSearch) refs.collectionSearch.value = "";
      if (refs.collectionCreateStatus) refs.collectionCreateStatus.textContent = payload.reused ? "Existing collection selected." : "Collection created and selected. Publish the collection separately in Shopify when ready.";
    } catch (error) {
      if (refs.collectionCreateStatus) refs.collectionCreateStatus.textContent = `Collection creation failed: ${error.message}`;
    } finally {
      state.collectionBusy = false;
      setLoading(false);
      renderCollectionPicker();
    }
  }

  function resetQuickForm() {
    state.editingItemId = "";
    refs.quickForm?.reset();
    setSelectedCollections(["New Arrivals"]);
    if (refs.collectionPicker) refs.collectionPicker.open = false;
    if (refs.quickButton) refs.quickButton.textContent = "Save product details";
    if (refs.editCancel) refs.editCancel.hidden = true;
    if (refs.formOptional) refs.formOptional.open = false;
    setFormError();
    refs.quickDetails?.classList.remove("is-editing");
    if (refs.localMedia) {
      refs.localMedia.value = "";
      refs.localMedia.hidden = true;
    }
    if (refs.mediaNote) refs.mediaNote.textContent = "Drive folder lookup will use the factory code when the Shopify plan runs.";
    ["vendor", "scale"].forEach((name) => {
      const other = refs.quickForm?.elements?.[`${name}_other`];
      if (other) other.hidden = true;
    });
    state.previewLocale = "en";
    updateConditionalFields();
    renderLocalPreview();
    renderQuickPreview();
  }

  function beginEdit(itemId) {
    const item = state.items.find((entry) => entry.item_id === itemId);
    if (!item || !refs.quickForm) return;
    const product = item.normalized || {};
    const ja = product.localizations?.ja || {};
    const zh = product.localizations?.["zh-CN"] || {};
    const values = {
      factory_code: product.factory_code || item.factory_code,
      title: product.title || item.title,
      subtitle: product.subtitle,
      body_html: product.body_html,
      title_ja: ja.title,
      subtitle_ja: ja.subtitle,
      body_html_ja: ja.body_html,
      title_zh: zh.title,
      subtitle_zh: zh.subtitle,
      body_html_zh: zh.body_html,
      vendor: product.vendor,
      vehicle_maker: product.vehicle_maker,
      color_livery: product.color_livery,
      limited_pcs: product.limited_pcs,
      scale: product.scale,
      material: product.material,
      tags: (product.tags || []).join(" | "),
      price: product.price,
      cost: product.cost,
      cost_currency: product.cost_currency || "JPY",
      inventory: product.inventory,
      weight: product.weight,
      stock_location: product.stock_location || "Ariake",
      action: product.action || "upsert",
      points_policy: product.points_policy || "standard",
      points_earn: product.points_earn,
      media_source: product.media_source || "drive",
    };
    Object.entries(values).forEach(([name, value]) => setQuickValue(name, value));
    setSelectedCollections(product.collections || []);
    state.editingItemId = itemId;
    if (refs.quickButton) refs.quickButton.textContent = "Save changes";
    if (refs.editCancel) refs.editCancel.hidden = false;
    refs.quickDetails?.classList.add("is-editing");
    if (refs.quickDetails) refs.quickDetails.open = true;
    if (refs.localMedia) refs.localMedia.hidden = values.media_source !== "local";
    if (refs.mediaNote) refs.mediaNote.textContent = values.media_source === "local"
      ? `${(item.media || []).length} existing local image${(item.media || []).length === 1 ? "" : "s"} staged. Choose files only to add more.`
      : "Drive folder lookup will use the factory code when the Shopify plan runs.";
    if (refs.formOptional) refs.formOptional.open = Boolean(product.action && product.action !== "upsert"
      || Object.values(ja).some(Boolean) || Object.values(zh).some(Boolean));
    const localizationDetails = refs.quickForm.querySelector(".kob-prc__localizations");
    if (localizationDetails) localizationDetails.open = Object.values(ja).some(Boolean) || Object.values(zh).some(Boolean);
    updateConditionalFields();
    setFormError();
    renderLocalPreview();
    renderQuickPreview();
    syncSourceButtons();
    refs.quickDetails?.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  function updateConditionalFields() {
    const explicit = refs.quickForm?.elements?.points_policy?.value === "explicit";
    if (refs.explicitPoints) refs.explicitPoints.hidden = !explicit;
    const pointsInput = refs.quickForm?.elements?.points_earn;
    if (pointsInput) pointsInput.required = explicit;
  }

  function setPreviewSpec(name, value) {
    const row = root.querySelector(`[data-kob-prc-preview-spec="${name}"]`);
    const output = row?.querySelector("dd");
    if (output) output.textContent = value || "—";
  }

  function editionValue(value) {
    const cleaned = String(value || "").trim().replace(/\s*(pcs?|pieces?)\s*$/i, "");
    return cleaned;
  }

  function localizedPreviewValue(field, locale, fallback) {
    if (locale === "en") return fallback;
    return quickValue(`${field}_${locale}`) || fallback;
  }

  function localizedSubtitle(locale, sourceSubtitle) {
    const supplied = localizedPreviewValue("subtitle", locale, "");
    if (supplied) return supplied;
    return locale === "en" ? sourceSubtitle : sourceSubtitle.replace(/^in\s+/i, "");
  }

  function renderQuickPreview() {
    if (!refs.quickForm) return;
    const locale = state.previewLocale;
    const copy = previewCopy[locale];
    const sourceTitle = quickValue("title");
    const color = quickValue("color_livery");
    const sourceSubtitle = quickValue("subtitle") || (color ? (/^in\s+/i.test(color) ? color : `in ${color}`) : "");
    const title = localizedPreviewValue("title", locale, sourceTitle) || copy.titleFallback;
    const subtitle = localizedSubtitle(locale, sourceSubtitle);
    const limitedValue = editionValue(quickValue("limited_pcs"));
    const limited = limitedValue ? copy.edition(limitedValue) : "";
    const price = Number(quickValue("price") || 0);
    const policy = quickValue("points_policy") || "standard";
    const explicitPoints = Number(quickValue("points_earn") || 0);
    const points = policy === "zero" ? 0 : (policy === "explicit" ? explicitPoints : Math.floor(price / 100));
    const location = quickValue("stock_location");
    const code = quickValue("factory_code");

    if (refs.previewMaker) refs.previewMaker.textContent = quickValue("vendor") || copy.makerFallback;
    if (refs.previewLimited) {
      refs.previewLimited.textContent = limited;
      refs.previewLimited.hidden = !limited;
    }
    if (refs.previewTitle) refs.previewTitle.textContent = title;
    if (refs.previewSubtitle) {
      refs.previewSubtitle.textContent = subtitle;
      refs.previewSubtitle.hidden = !subtitle;
    }
    if (refs.previewPrice) refs.previewPrice.textContent = `JPY ${formatNumber(price)}`;
    if (refs.previewPoints) refs.previewPoints.textContent = `${formatNumber(points)} KoB Points`;
    if (refs.previewShip) refs.previewShip.textContent = location === "Shanghai Warehouse" ? copy.shipShanghai : copy.shipTokyo;
    if (refs.previewMedia) refs.previewMedia.textContent = code ? `${code} / Drive image preview` : "Drive image preview";
    setPreviewSpec("scale", quickValue("scale"));
    const material = quickValue("material");
    setPreviewSpec("material", copy.materials[material] || material);
    setPreviewSpec("code", code);
    refs.previewLabels.forEach((element) => { element.textContent = copy.labels[element.dataset.kobPrcPreviewLabel] || ""; });
    refs.previewActions.forEach((element) => { element.textContent = copy.actions[element.dataset.kobPrcPreviewAction] || ""; });
    if (refs.previewNote) refs.previewNote.textContent = copy.note;
    refs.previewLanguageButtons.forEach((button) => button.setAttribute("aria-pressed", String(button.dataset.kobPrcPreviewLanguage === locale)));
  }

  function renderLocalPreview() {
    if (!refs.previewImage) return;
    if (state.previewMediaUrl) URL.revokeObjectURL(state.previewMediaUrl);
    state.previewMediaUrl = "";
    const localSelected = refs.quickForm?.elements?.media_source?.value === "local";
    const file = localSelected ? refs.localMedia?.files?.[0] : null;
    if (!file) {
      refs.previewImage.hidden = true;
      refs.previewImage.removeAttribute("src");
      return;
    }
    state.previewMediaUrl = URL.createObjectURL(file);
    refs.previewImage.src = state.previewMediaUrl;
    refs.previewImage.alt = quickValue("title") || "Local product image preview";
    refs.previewImage.hidden = false;
  }

  refs.importForm?.querySelector('input[type="file"]')?.addEventListener("change", (event) => {
    if (refs.fileName) refs.fileName.textContent = event.target.files?.[0]?.name || "No file selected";
  });

  refs.openManual?.addEventListener("click", () => {
    if (refs.quickDetails) refs.quickDetails.open = true;
    if (refs.arrivalPanel) refs.arrivalPanel.hidden = true;
    syncSourceButtons();
    refs.quickDetails?.scrollIntoView({ behavior: "smooth", block: "start" });
    refs.quickForm?.elements?.factory_code?.focus();
  });
  refs.openArrivals?.addEventListener("click", () => {
    if (refs.arrivalPanel) refs.arrivalPanel.hidden = false;
    if (refs.quickDetails) refs.quickDetails.open = false;
    syncSourceButtons();
    refs.arrivalPanel?.scrollIntoView({ behavior: "smooth", block: "start" });
    loadArrivalCandidates();
  });
  refs.quickDetails?.addEventListener("toggle", syncSourceButtons);
  refs.arrivalList?.addEventListener("click", (event) => {
    const button = event.target.closest("[data-kob-prc-arrival-batch]");
    if (!button) return;
    const batchId = button.dataset.kobPrcArrivalBatch || "";
    state.selectedBatchId = batchId;
    load(batchId).then(() => refs.toolbar?.scrollIntoView({ behavior: "smooth", block: "start" }))
      .catch((error) => toast(error.message));
  });

  refs.quickForm?.addEventListener("input", () => {
    setFormError();
    renderQuickPreview();
  });
  refs.quickForm?.addEventListener("change", () => {
    const local = refs.quickForm.elements.media_source?.value === "local";
    if (refs.localMedia) refs.localMedia.hidden = !local;
    if (refs.mediaNote) refs.mediaNote.textContent = local
      ? "Files are staged privately when details are saved. Shopify receives them only during Draft creation."
      : "Drive folder lookup will use the factory code when the Shopify plan runs.";
    if (!local) renderLocalPreview();
    ["vendor", "scale"].forEach((name) => {
      const field = refs.quickForm?.elements?.[name];
      const other = refs.quickForm?.elements?.[`${name}_other`];
      if (other) other.hidden = field?.value !== "Other";
    });
    updateConditionalFields();
    renderQuickPreview();
  });
  refs.localMedia?.addEventListener("change", () => {
    renderLocalPreview();
    renderQuickPreview();
  });
  refs.previewLanguageButtons.forEach((button) => button.addEventListener("click", () => {
    state.previewLocale = button.dataset.kobPrcPreviewLanguage || "en";
    renderQuickPreview();
  }));
  refs.collectionSearch?.addEventListener("input", renderCollectionPicker);
  refs.collectionRefresh?.addEventListener("click", refreshCollections);
  refs.collectionTitle?.addEventListener("input", updateCollectionCreateButton);
  refs.collectionConfirm?.addEventListener("change", updateCollectionCreateButton);
  refs.collectionCreate?.addEventListener("click", createCollection);
  refs.editCancel?.addEventListener("click", resetQuickForm);
  document.addEventListener("click", (event) => {
    if (refs.collectionPicker?.open && !refs.collectionPicker.contains(event.target)) refs.collectionPicker.open = false;
  });
  refs.items?.addEventListener("click", (event) => {
    const edit = event.target.closest("[data-kob-prc-edit-item]");
    if (edit) return beginEdit(edit.dataset.kobPrcEditItem || "");
    const action = event.target.closest("[data-kob-prc-row-action]");
    if (!action || state.loading) return;
    const kind = action.dataset.kobPrcRowAction;
    if (kind === "edit") return beginEdit(action.dataset.kobPrcRowId || "");
    if (kind === "recovery") {
      const details = root.querySelector(".kob-prc__execution");
      if (details) details.open = true;
      details?.scrollIntoView({ behavior: "smooth", block: "start" });
      return;
    }
    if (kind === "review") {
      const card = Array.from(refs.publications?.querySelectorAll("[data-kob-prc-publication]") || [])
        .find((entry) => entry.dataset.kobPrcPublication === action.dataset.kobPrcRowId);
      (card || refs.publications)?.scrollIntoView({ behavior: "smooth", block: "start" });
      return;
    }
    if (kind === "refresh-review") return refs.refreshPublications?.click();
    if (kind === "live-stock") return openLiveStock(action.dataset.kobPrcRowId || "");
    if (kind === "workflow") {
      refs.toolbar?.scrollIntoView({ behavior: "smooth", block: "start" });
      refs.startWorkflow?.focus();
    }
  });
  refs.liveClose?.addEventListener("click", () => {
    if (refs.liveStock) refs.liveStock.hidden = true;
    state.liveStockItemId = "";
    clearLiveStockReview();
  });
  refs.liveLocation?.addEventListener("change", () => {
    clearLiveStockReview("Location changed. Read the current stock at this location before entering a target.");
    if (refs.liveReceipt) refs.liveReceipt.hidden = true;
  });
  refs.livePreviewButton?.addEventListener("click", readLiveStock);
  refs.liveTarget?.addEventListener("input", updateLiveApplyState);
  refs.liveConfirm?.addEventListener("change", updateLiveApplyState);
  refs.liveForm?.addEventListener("submit", applyLiveStock);
  refs.liveNewDraft?.addEventListener("click", () => {
    const itemId = state.liveStockItemId;
    if (refs.liveStock) refs.liveStock.hidden = true;
    beginEdit(itemId);
    refs.quickForm?.elements?.action?.focus();
    toast("Shopify search found no exact match. Verify directly in Shopify before selecting a new Draft action.");
  });
  refs.executions?.addEventListener("click", async (event) => {
    const button = event.target.closest("[data-kob-prc-retry-step]");
    if (!button || state.loading) return;
    setLoading(true);
    try {
      await api("/product-releases/execution-retry", {
        method: "POST",
        body: JSON.stringify({ step_id: button.dataset.kobPrcRetryStep || "" }),
      });
      await load(state.selectedBatchId);
      toast("Step reset. Continue the Draft run when the executor is enabled.");
    } catch (error) {
      toast(`Retry failed: ${error.message}`);
    } finally {
      setLoading(false);
    }
  });

  refs.quickForm?.addEventListener("submit", async (event) => {
    event.preventDefault();
    setFormError();
    const form = new FormData(refs.quickForm);
    const mediaSource = String(form.get("media_source") || "drive");
    const editingItem = state.items.find((item) => item.item_id === state.editingItemId);
    const hasExistingLocalMedia = mediaSource === "local" && (editingItem?.media || []).length > 0;
    if (mediaSource === "local" && !(refs.localMedia?.files || []).length && !hasExistingLocalMedia) {
      setFormError("Choose at least one local original image, or select the Drive source.");
      refs.localMedia?.focus();
      return;
    }
    const product = {
      Title: form.get("title"),
      Subtitle: form.get("subtitle"),
      "Body (HTML)": form.get("body_html"),
      TitleJA: form.get("title_ja"),
      SubtitleJA: form.get("subtitle_ja"),
      BodyJA: form.get("body_html_ja"),
      TitleZH: form.get("title_zh"),
      SubtitleZH: form.get("subtitle_zh"),
      BodyZH: form.get("body_html_zh"),
      Vendor: form.get("vendor") === "Other" ? form.get("vendor_other") : form.get("vendor"),
      "Vehicle Maker": form.get("vehicle_maker"),
      Color: form.get("color_livery"),
      "Limited pcs": form.get("limited_pcs"),
      Scale: form.get("scale") === "Other" ? form.get("scale_other") : form.get("scale"),
      Material: form.get("material"),
      Tags: form.get("tags"),
      FactoryCode: form.get("factory_code"),
      Price: form.get("price"),
      Cost: form.get("cost"),
      CostCurrency: form.get("cost_currency"),
      Inventory: form.get("inventory"),
      Weight: form.get("weight"),
      Collections: selectedCollections(),
      StockLocation: form.get("stock_location"),
      Action: form.get("action"),
      PointsPolicy: form.get("points_policy"),
      PointsEarn: form.get("points_earn"),
      EmailAnnounce: "no",
      SocialAnnounce: "no",
      MediaSource: mediaSource,
      MediaReference: mediaSource === "drive" ? form.get("factory_code") : "",
    };
    let savedRecord = null;
    let saveStage = "record";
    setLoading(true);
    try {
      const editing = Boolean(state.editingItemId);
      const payload = await api(editing ? "/product-releases/item-update" : "/product-releases/quick-add", {
        method: "POST",
        body: JSON.stringify({
          item_id: state.editingItemId,
          title: `${form.get("factory_code")} / ${form.get("title")}`,
          default_cost_currency: form.get("cost_currency"),
          product,
        }),
      });
      savedRecord = payload;
      if (!payload.duplicate && mediaSource === "local" && (refs.localMedia?.files || []).length) {
        saveStage = "images";
        const files = refs.localMedia?.files || [];
        const mediaForm = new FormData();
        mediaForm.set("item_id", payload.item_id);
        Array.from(files).forEach((file) => mediaForm.append("files", file));
        await api("/product-releases/media", { method: "POST", body: mediaForm });
      }
      saveStage = "refresh";
      state.selectedBatchId = payload.batch_id;
      await load(payload.batch_id);
      resetQuickForm();
      if (refs.quickDetails) refs.quickDetails.open = false;
      syncSourceButtons();
      refs.toolbar?.scrollIntoView({ behavior: "smooth", block: "start" });
      toast(payload.duplicate
        ? "This product draft already exists. Existing batch opened."
        : (editing ? "Product details updated; previous Shopify plan was invalidated." : "Product details saved. No Shopify product was created."));
    } catch (error) {
      if (savedRecord?.batch_id) {
        state.selectedBatchId = savedRecord.batch_id;
        await load(savedRecord.batch_id).catch(() => {});
        if (savedRecord.item_id) beginEdit(savedRecord.item_id);
        const detail = saveStage === "images"
          ? "Product details were saved, but the local original upload failed. Select the files again and save changes."
          : "Product details were saved, but the refreshed queue could not be loaded. Refresh the page before continuing.";
        setFormError(`${detail} ${error.message}`);
        toast("Product record saved; a later step needs attention.");
      } else {
        setFormError(`Could not save product details: ${error.message}`);
        toast("Product details were not saved. Check the form error.");
      }
    } finally {
      setLoading(false);
    }
  });

  refs.importForm?.addEventListener("submit", async (event) => {
    event.preventDefault();
    const form = new FormData(refs.importForm);
    const file = form.get("csv_file");
    if (!(file instanceof File) || !file.size) return toast("Choose a CSV file first.");
    setLoading(true);
    try {
      const payload = await api("/product-releases/import", {
        method: "POST",
        body: JSON.stringify({
          title: form.get("title"),
          default_cost_currency: form.get("default_cost_currency"),
          source_label: file.name,
          csv_text: await file.text(),
        }),
      });
      state.selectedBatchId = payload.batch_id;
      await load(payload.batch_id);
      refs.importForm.reset();
      if (refs.fileName) refs.fileName.textContent = "No file selected";
      if (refs.bulkDetails) refs.bulkDetails.open = false;
      refs.toolbar?.scrollIntoView({ behavior: "smooth", block: "start" });
      toast(payload.duplicate ? "This CSV was already imported. Existing batch opened." : "Batch imported. No Shopify changes were made.");
    } catch (error) {
      toast(`Import failed: ${error.message}`);
    } finally {
      setLoading(false);
    }
  });

  refs.batchSelect?.addEventListener("change", () => {
    state.selectedBatchId = refs.batchSelect.value;
    load(state.selectedBatchId).catch((error) => toast(error.message));
  });
  refs.filter?.addEventListener("change", renderItems);
  refs.refresh?.addEventListener("click", () => load().catch((error) => toast(error.message)));
  refs.startWorkflow?.addEventListener("click", () => runDraftWorkflow());
  refs.revalidate?.addEventListener("click", async () => {
    if (!state.selectedBatchId) return;
    setLoading(true);
    try {
      await api("/product-releases/revalidate", { method: "POST", body: JSON.stringify({ batch_id: state.selectedBatchId }) });
      await load(state.selectedBatchId);
      toast("Preflight completed. No Shopify changes were made.");
    } catch (error) {
      toast(`Preflight failed: ${error.message}`);
    } finally {
      setLoading(false);
    }
  });
  refs.plan?.addEventListener("click", async () => {
    if (!state.selectedBatchId) return;
    setLoading(true);
    try {
      await api("/product-releases/plan", { method: "POST", body: JSON.stringify({ batch_id: state.selectedBatchId }) });
      await load(state.selectedBatchId);
      toast("Shopify plan built from read-only data. No Shopify changes were made.");
    } catch (error) {
      toast(`Plan failed: ${error.message}`);
    } finally {
      setLoading(false);
    }
  });
  refs.prepareExecution?.addEventListener("click", async () => {
    if (!state.selectedBatchId) return;
    setLoading(true);
    try {
      const payload = await api("/product-releases/execution-prepare", {
        method: "POST",
        body: JSON.stringify({ batch_id: state.selectedBatchId }),
      });
      await load(state.selectedBatchId);
      toast(payload.duplicate
        ? "Existing Draft execution opened. No Shopify write was made."
        : "Draft execution prepared. No Shopify write was made.");
    } catch (error) {
      toast(`Execution preparation failed: ${error.message}`);
    } finally {
      setLoading(false);
    }
  });
  refs.continueExecution?.addEventListener("click", async () => {
    const run = activeRun();
    if (!run) return;
    if (!run.started_at && !window.confirm("Run the reviewed Shopify Draft plan? Products will remain Draft and no publication, email or social action can occur.")) return;
    setLoading(true);
    try {
      const payload = await api("/product-releases/execution-continue", {
        method: "POST",
        body: JSON.stringify({ run_id: run.run_id }),
      });
      await load(state.selectedBatchId);
      toast(`Draft run step: ${payload.step_result || (payload.no_op ? "no change" : "completed")}.`);
    } catch (error) {
      toast(`Draft execution failed: ${error.message}`);
    } finally {
      setLoading(false);
    }
  });

  async function runDraftWorkflow() {
    if (!state.selectedBatchId || !canStartWorkflow()) return;
    const existing = activeRun();
    if (!existing && !window.confirm("Create or update these products as Shopify Drafts? Nothing will be published until you approve it in the next section.")) return;
    state.workflowRunning = true;
    setLoading(true);
    renderWorkflowStatus();
    try {
      let run = existing;
      if (!run) {
        await api("/product-releases/revalidate", {
          method: "POST",
          body: JSON.stringify({ batch_id: state.selectedBatchId }),
        });
        await api("/product-releases/plan", {
          method: "POST",
          body: JSON.stringify({ batch_id: state.selectedBatchId }),
        });
        await load(state.selectedBatchId);
        const blocked = state.items.filter((item) => !item.plan || !["ready", "skipped"].includes(item.plan.status));
        if (blocked.length) {
          refs.items?.closest(".kob-prc__workspace")?.scrollIntoView({ behavior: "smooth", block: "start" });
          toast(`${blocked.length} product(s) need review before Shopify Draft creation.`);
          return;
        }
        setLoading(true);
        const prepared = await api("/product-releases/execution-prepare", {
          method: "POST",
          body: JSON.stringify({ batch_id: state.selectedBatchId }),
        });
        run = prepared.run;
      }

      for (let attempt = 0; attempt < 180; attempt += 1) {
        if (!run || ["completed", "completed_with_errors", "cancelled", "blocked"].includes(run.status)) break;
        const result = await api("/product-releases/execution-continue", {
          method: "POST",
          body: JSON.stringify({ run_id: run.run_id }),
        });
        run = result.run || run;
        state.runs = [run, ...state.runs.filter((entry) => entry.run_id !== run.run_id)];
        renderExecutions();
        renderItems();
        renderWorkflowStatus();
        if (result.no_op || result.step_result === "waiting") {
          const retryAfter = Number(result.retry_after_ms);
          const pause = Number.isFinite(retryAfter) && retryAfter > 0 ? Math.min(10000, Math.max(250, retryAfter)) : 1400;
          await new Promise((resolve) => window.setTimeout(resolve, pause));
        }
      }

      if (run && !["completed", "completed_with_errors", "cancelled", "blocked"].includes(run.status)) {
        toast("Draft creation progress was saved. Press Continue Shopify Drafts to resume.");
      } else {
        try {
          await api("/product-releases/publications/refresh", {
            method: "POST",
            body: JSON.stringify({ batch_id: state.selectedBatchId }),
          });
        } catch (error) {
          if (run?.completed_count) throw error;
        }
        toast(run?.status === "completed_with_errors"
          ? "Draft creation finished. Successful products are ready for review; failed products were safely skipped."
          : "All Shopify Drafts are ready for review.");
      }
    } catch (error) {
      toast(`Draft workflow paused: ${error.message}. Saved progress can be resumed safely.`);
    } finally {
      state.workflowRunning = false;
      await load(state.selectedBatchId).catch(() => {});
      setLoading(false);
    }
  }

  refs.refreshPublications?.addEventListener("click", async () => {
    if (!state.selectedBatchId) return;
    setLoading(true);
    try {
      const refreshed = await api("/product-releases/publications/refresh", {
        method: "POST",
        body: JSON.stringify({ batch_id: state.selectedBatchId }),
      });
      recordSnsHandoffs(refreshed.sns_handoffs);
      await load(state.selectedBatchId);
      toast(refreshed.sns_handoffs?.some((entry) => !entry.ok)
        ? "Shopify review refreshed; an SNS handoff still needs attention." : "Shopify Draft review refreshed.");
    } catch (error) {
      toast(`Review refresh failed: ${error.message}`);
    } finally {
      setLoading(false);
    }
  });

  refs.publications?.addEventListener("change", () => {
    if (refs.publishSelected) refs.publishSelected.disabled = state.loading || !publishableSelections().length;
  });

  refs.publications?.addEventListener("click", async (event) => {
    const button = event.target.closest("[data-kob-prc-check-sns-handoff]");
    if (!button || state.loading) return;
    const id = button.dataset.kobPrcCheckSnsHandoff || "";
    setLoading(true);
    try {
      const result = await api("/product-releases/publications/refresh", {
        method: "POST", body: JSON.stringify({ publication_record_id: id }),
      });
      recordSnsHandoffs(result.sns_handoffs);
      if (!result.sns_handoffs?.some((entry) => entry.publication_record_id === id)) {
        state.snsHandoffWarnings[id] = "status not returned";
      }
      await load(state.selectedBatchId);
      toast(state.snsHandoffWarnings[id] ? "SNS handoff is still pending. See the published product card." : "SNS handoff confirmed in the separate workspace.");
    } catch (error) {
      state.snsHandoffWarnings[id] = error.message;
      renderPublications();
      toast("SNS handoff check could not finish. The product page remains published.");
    } finally {
      setLoading(false);
    }
  });

  refs.publishSelected?.addEventListener("click", async () => {
    const selected = publishableSelections().map((input) => state.publications.find((record) => record.publication_record_id === input.value)).filter(Boolean);
    if (!selected.length) return;
    if (!window.confirm(`Publish ${selected.length} selected product${selected.length === 1 ? "" : "s"} to the Online Store? Each product will be verified again before publication.`)) return;
    setLoading(true);
    const failures = [];
    let published = 0;
    let handoffPending = 0;
    try {
      for (const record of selected) {
        try {
          const result = await api("/product-releases/publications/publish", {
            method: "POST",
            body: JSON.stringify({
              publication_record_id: record.publication_record_id,
              snapshot_hash: record.snapshot_hash,
            }),
          });
          if (result.sns_handoff?.ok === false) {
            state.snsHandoffWarnings[record.publication_record_id] = result.sns_handoff.error || "candidate not yet saved";
            handoffPending += 1;
          } else if (result.sns_handoff?.ok) {
            delete state.snsHandoffWarnings[record.publication_record_id];
          }
          published += 1;
        } catch (error) {
          failures.push(`${record.snapshot?.factory_code || record.item_id}: ${error.message}`);
        }
      }
      const refreshed = await api("/product-releases/publications/refresh", {
        method: "POST",
        body: JSON.stringify({ batch_id: state.selectedBatchId }),
      }).catch(() => {});
      recordSnsHandoffs(refreshed?.sns_handoffs);
      await api("/product-releases/communications/refresh", {
        method: "POST",
        body: JSON.stringify({ batch_id: state.selectedBatchId }),
      }).catch(() => {});
      await load(state.selectedBatchId);
      toast(failures.length
        ? `${published} published; ${failures.length} product(s) need attention. ${failures[0]}`
        : handoffPending || refreshed?.sns_handoffs?.some((entry) => !entry.ok)
          ? `${published} product${published === 1 ? "" : "s"} published; SNS handoff needs attention on the product card.`
          : `${published} product${published === 1 ? "" : "s"} published and verified.`);
    } finally {
      setLoading(false);
    }
  });

  refs.refreshCommunications?.addEventListener("click", async () => {
    if (!state.selectedBatchId) return;
    setLoading(true);
    try {
      await api("/product-releases/communications/refresh", {
        method: "POST",
        body: JSON.stringify({ batch_id: state.selectedBatchId }),
      });
      await load(state.selectedBatchId);
      toast("Publication status and campaign assets refreshed from Shopify.");
    } catch (error) {
      toast(`Communication refresh failed: ${error.message}`);
    } finally {
      setLoading(false);
    }
  });

  refs.communications?.addEventListener("click", async (event) => {
    const card = event.target.closest("[data-kob-prc-communication]");
    if (!card) return;
    const communicationId = card.dataset.kobPrcCommunication;
    if (event.target.closest("[data-kob-prc-save-communication]")) {
      await saveCommunication(card, communicationId, true);
      return;
    }
    if (event.target.closest("[data-kob-prc-export-email]")) {
      await exportEmail(card, communicationId);
      return;
    }
    if (event.target.closest("[data-kob-prc-generate-introduction]")) {
      await generateSocialIntroduction(card, communicationId);
      return;
    }
    if (event.target.closest("[data-kob-prc-cancel-communication]")) {
      await cancelCommunication(card, communicationId);
      return;
    }
    if (event.target.closest("[data-kob-prc-publish-social]")) {
      await publishSocial(card, communicationId);
    }
  });

  refs.communications?.addEventListener("input", (event) => {
    const input = event.target.closest("[data-kob-prc-communication-introduction]");
    if (!input) return;
    const card = input.closest("[data-kob-prc-communication]");
    const caption = card?.querySelector("[data-kob-prc-communication-caption]");
    if (!caption) return;
    const previous = input.dataset.previousValue ?? state.communications.find((item) => item.communication_id === card.dataset.kobPrcCommunication)?.social_introduction ?? "";
    const next = input.value.trim();
    if (previous && caption.value.includes(previous)) {
      caption.value = caption.value.replace(previous, next);
    } else if (!previous && next) {
      const blocks = caption.value.split(/\n\n+/);
      blocks.splice(Math.min(1, blocks.length), 0, next);
      caption.value = blocks.filter(Boolean).join("\n\n");
    }
    input.dataset.previousValue = next;
  });

  async function saveCommunication(card, communicationId, showToast = false, useGlobalLoading = true) {
    const current = state.communications.find((item) => item.communication_id === communicationId) || {};
    if (useGlobalLoading) setLoading(true);
    try {
      const payload = await api("/product-releases/communications/update", {
        method: "POST",
        body: JSON.stringify({
          communication_id: communicationId,
          subject: card.querySelector("[data-kob-prc-communication-subject]")?.value || current.subject || "",
          body_text: card.querySelector("[data-kob-prc-communication-body]")?.value || current.body_text || "",
          body_html: current.body_html || "",
          caption: card.querySelector("[data-kob-prc-communication-caption]")?.value ?? current.caption ?? "",
          social_introduction: card.querySelector("[data-kob-prc-communication-introduction]")?.value ?? current.social_introduction ?? "",
        }),
      });
      const index = state.communications.findIndex((item) => item.communication_id === communicationId);
      if (index >= 0 && payload.communication) state.communications[index] = payload.communication;
      if (showToast) toast("Communication copy saved.");
      return payload.communication;
    } catch (error) {
      toast(`Unable to save communication copy: ${error.message}`);
      throw error;
    } finally {
      if (useGlobalLoading) setLoading(false);
    }
  }

  async function cancelCommunication(card, communicationId) {
    const current = state.communications.find((item) => item.communication_id === communicationId);
    if (!current) return;
    const label = current.channel === "social" ? "IG/FB publication task" : "email task";
    if (!window.confirm(`Abandon this ${label}? It will be removed from the active queue, while the audit record is retained.`)) return;
    setCommunicationBusy(card, true, "Removing task...");
    try {
      await api("/product-releases/communications/cancel", {
        method: "POST",
        body: JSON.stringify({ communication_id: communicationId }),
      });
      state.communications = state.communications.filter((item) => item.communication_id !== communicationId);
      renderCommunications();
      toast("Communication task removed from the active queue.");
    } catch (error) {
      toast(`Unable to abandon task: ${error.message}`);
    } finally {
      setCommunicationBusy(card, false);
    }
  }

  async function generateSocialIntroduction(card, communicationId) {
    const current = state.communications.find((item) => item.communication_id === communicationId);
    if (!current) return;
    if (current.caption_generation?.provider && !window.confirm("Replace the existing researched introduction? The full caption will be rebuilt and can still be edited before publishing.")) return;
    setLoading(true);
    try {
      const payload = await api("/product-releases/communications/generate-introduction", {
        method: "POST",
        body: JSON.stringify({ communication_id: communicationId }),
      });
      const index = state.communications.findIndex((item) => item.communication_id === communicationId);
      if (index >= 0 && payload.communication) state.communications[index] = payload.communication;
      renderCommunications();
      toast(`Researched introduction generated with ${payload.communication?.caption_generation?.provider || state.captionGenerationPrimary}. Review it before publishing.`);
    } catch (error) {
      toast(`Introduction generation failed: ${error.message}`);
    } finally {
      setLoading(false);
    }
  }

  async function exportEmail(card, communicationId) {
    try {
      const saved = await saveCommunication(card, communicationId);
      const payload = await api("/product-releases/communications/email-exported", {
        method: "POST",
        body: JSON.stringify({ communication_id: communicationId }),
      });
      const communication = payload.communication || saved;
      const filename = `${communication.product_handle || "kind-of-blu-new-arrival"}-email.html`;
      downloadText(filename, communication.body_html || "", "text/html;charset=utf-8");
      if (communication.subject && navigator.clipboard?.writeText) {
        navigator.clipboard.writeText(communication.subject).catch(() => {});
      }
      await load(state.selectedBatchId);
      toast("Email HTML downloaded. Subject copied when browser permission allowed.");
    } catch (error) {
      toast(`Email export failed: ${error.message}`);
    }
  }

  async function publishSocial(card, communicationId) {
    const current = state.communications.find((item) => item.communication_id === communicationId);
    if (!current) return;
    const started = Boolean(current.provider_state?.ig_child_ids?.length || current.provider_state?.ig_container_id || current.provider_state?.ig_media_id);
    if (!started && !window.confirm("Publish this reviewed carousel to Instagram and Facebook? The product must already be public, and progress will be saved after every provider step.")) return;
    try {
      await saveCommunication(card, communicationId, false, false);
      setCommunicationBusy(card, true, "Starting Instagram publication...");
      for (let attempt = 0; attempt < 30; attempt += 1) {
        const payload = await api("/product-releases/communications/social-continue", {
          method: "POST",
          body: JSON.stringify({ communication_id: communicationId }),
        });
        const communication = payload.communication || {};
        updateCommunicationState(communication);
        updateCommunicationCardProgress(card, communication);
        if (communication.status === "published") {
          renderCommunications();
          toast("Instagram and Facebook publication completed.");
          return;
        }
        if (communication.status === "failed") {
          renderCommunications();
          toast(`IG/FB paused: ${communication.error_message || "provider step failed"}`);
          return;
        }
        await new Promise((resolve) => window.setTimeout(resolve, 900));
      }
      renderCommunications();
      toast("IG/FB progress saved. Continue the task to resume.");
    } catch (error) {
      toast(`IG/FB publish failed: ${error.message}`);
    } finally {
      setCommunicationBusy(card, false);
    }
  }

  function updateCommunicationState(communication) {
    if (!communication?.communication_id) return;
    const index = state.communications.findIndex((item) => item.communication_id === communication.communication_id);
    if (index >= 0) state.communications[index] = communication;
  }

  function updateCommunicationCardProgress(card, communication) {
    const progress = card?.querySelector("[data-kob-prc-communication-progress]");
    const status = card?.querySelector("[data-kob-prc-communication-status]");
    if (progress) {
      const media = communication.media || [];
      progress.textContent = `${socialProgress(communication.provider_state || {}, media)} / ${media.length} image${media.length === 1 ? "" : "s"}`;
    }
    if (status) status.textContent = communication.status || "publishing";
  }

  function setCommunicationBusy(card, value, message = "") {
    if (!card) return;
    card.classList.toggle("is-working", value);
    card.querySelectorAll("button, input, textarea").forEach((control) => {
      if (value) {
        control.dataset.kobPrcWasDisabled = control.disabled ? "true" : "false";
        control.disabled = true;
      } else {
        if (control.dataset.kobPrcWasDisabled === "false") control.disabled = false;
        delete control.dataset.kobPrcWasDisabled;
      }
    });
    const progress = card.querySelector("[data-kob-prc-communication-progress]");
    if (value && message && progress) progress.textContent = message;
  }

  function downloadText(filename, content, type) {
    const url = URL.createObjectURL(new Blob([content], { type }));
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.setTimeout(() => URL.revokeObjectURL(url), 1000);
  }

  function escapeHtml(value) {
    return String(value == null ? "" : value).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
  }
  function formatNumber(value) { return Number.isFinite(Number(value)) ? new Intl.NumberFormat("en-US").format(Number(value)) : "-"; }
  function formatDate(value) { const date = new Date(value); return Number.isNaN(date.valueOf()) ? String(value || "") : date.toLocaleString(); }

  renderQuickPreview();
  const linkedBatchId = new URL(window.location.href).searchParams.get("batch_id") || "";
  load(/^prb_[a-z0-9-]{1,100}$/i.test(linkedBatchId) ? linkedBatchId : "")
    .catch((error) => toast(`Unable to load product releases: ${error.message}`));
})();
